<template>
  <v-app id="onboarding_container">
    <app-bar/>
    <v-main class="wrapper">
      <v-container  class="container" fluid>
        <slot class="slot"></slot>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import { LayoutComponents } from "../components";
export default {
  components: {
    ...LayoutComponents,
  },
  data() {
    return {
        toggleNavigation: false
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  margin-bottom: 100px;
}
</style>


// WEBPACK FOOTER //
// src/layouts/Default.vue